//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import "@/mixins/global";
import chartOTPDoc from "../../components/chartOTPDocument";
import chartOTP from "../../components/chartOTPPurchase";
import axios, { CancelToken } from "axios";

export default {
  components: {
    chartOTP,
    chartOTPDoc,
  },
  data() {
    return {
      ps: "202001",
      pe: "202053",
      chartDoc: [],
      teamD1: [],
      teamD2: [],
      teamD3: [],
      teamD4: [],
      teamD5: [],

      chartSample: [],
      teamS1: [],
      teamS2: [],
      teamS3: [],
      teamS4: [],
      teamS5: [],

      chart1: {
        ALL: [],
        G1: [],
        G2: [],
        G3: [],
        G4: [],
      },

      chart2: {
        ALL: [],
        G1: [],
        G2: [],
        G3: [],
        G4: [],
      },

      chart3: {
        ALL: [],
        G1: [],
        G2: [],
        G3: [],
        G4: [],
      },

      api: `${this.$apiFix}`,
    };
  },
  async mounted() {
    let a = await this.defaultPeriod();
    this.loadData();
  },
  methods: {
    defaultPeriod() {
      let params = new FormData();
      const obj = axios({
        method: "post",
        url: this.$api + "otpmaster.php/otperiod",
        data: params,
      }).then((res) => {
        this.ps = res.data.ps;
        this.pe = res.data.pe;
      });

      return obj;
    },
    loadData() {
      axios
        .get(
          `${this.api}otp_nike.php/nike_doc?ps=${this.ps}&pe=${this.pe}&grp=NIKE&team=`
        )
        .then((response) => {
          // console.log(response.data);
          this.chartDoc = response.data;
        });
      axios
        .get(
          `${this.api}otp_nike.php/nike_doc?ps=${this.ps}&pe=${this.pe}&grp=NIKE&team=TH NAY1-1`
        )
        .then((response) => {
          this.teamD1 = response.data;
        });
      axios
        .get(
          `${this.api}otp_nike.php/nike_doc?ps=${this.ps}&pe=${this.pe}&grp=NIKE&team=TH NAY1-2`
        )
        .then((response) => {
          this.teamD2 = response.data;
        });
      axios
        .get(
          `${this.api}otp_nike.php/nike_doc?ps=${this.ps}&pe=${this.pe}&grp=NIKE&team=TH NAY1-3`
        )
        .then((response) => {
          this.teamD3 = response.data;
        });
      axios
        .get(
          `${this.api}otp_nike.php/nike_doc?ps=${this.ps}&pe=${this.pe}&grp=NIKE&team=VN NAY1-1`
        )
        .then((response) => {
          this.teamD4 = response.data;
        });
      axios
        .get(
          `${this.api}otp_nike.php/nike_doc?ps=${this.ps}&pe=${this.pe}&grp=NIKE&team=VN NAY1-2`
        )
        .then((response) => {
          this.teamD5 = response.data;
        });

      axios
        .get(
          `${this.api}otp_nike.php/nike_sample?ps=${this.ps}&pe=${this.pe}&grp=NIKE&team=`
        )
        .then((response) => {
          this.chartSample = response.data;
        });
      axios
        .get(
          `${this.api}otp_nike.php/nike_sample?ps=${this.ps}&pe=${this.pe}&grp=NIKE&team=TH NAY1-1`
        )
        .then((response) => {
          this.teamS1 = response.data;
        });
      axios
        .get(
          `${this.api}otp_nike.php/nike_sample?ps=${this.ps}&pe=${this.pe}&grp=NIKE&team=TH NAY1-2`
        )
        .then((response) => {
          this.teamS2 = response.data;
        });
      axios
        .get(
          `${this.api}otp_nike.php/nike_sample?ps=${this.ps}&pe=${this.pe}&grp=NIKE&team=TH NAY1-3`
        )
        .then((response) => {
          this.teamS3 = response.data;
        });
      axios
        .get(
          `${this.api}otp_nike.php/nike_sample?ps=${this.ps}&pe=${this.pe}&grp=NIKE&team=VN NAY1-1`
        )
        .then((response) => {
          this.teamS4 = response.data;
        });
      axios
        .get(
          `${this.api}otp_nike.php/nike_sample?ps=${this.ps}&pe=${this.pe}&grp=NIKE&team=VN NAY1-2`
        )
        .then((response) => {
          this.teamS5 = response.data;
        });

      axios
        .get(`${this.api}otp_fabric.php/nike?ps=${this.ps}&pe=${this.pe}&loc=`)
        .then((response) => {
          // console.log(response.data)
          this.chart1.ALL = response.data;
        });
      axios
        .get(
          `${this.api}otp_fabric.php/nike?ps=${this.ps}&pe=${this.pe}&loc=G1`
        )
        .then((response) => {
          this.chart1.G1 = response.data;
        });
      axios
        .get(
          `${this.api}otp_fabric.php/nike?ps=${this.ps}&pe=${this.pe}&loc=G2`
        )
        .then((response) => {
          this.chart1.G2 = response.data;
        });
      axios
        .get(
          `${this.api}otp_fabric.php/nike?ps=${this.ps}&pe=${this.pe}&loc=G3`
        )
        .then((response) => {
          this.chart1.G3 = response.data;
        });
      axios
        .get(
          `${this.api}otp_fabric.php/nike?ps=${this.ps}&pe=${this.pe}&loc=G4`
        )
        .then((response) => {
          this.chart1.G4 = response.data;
        });

      axios
        .get(`${this.api}otp_sew.php/nike?ps=${this.ps}&pe=${this.pe}&loc=`)
        .then((response) => {
          this.chart2.ALL = response.data;
        });
      axios
        .get(`${this.api}otp_sew.php/nike?ps=${this.ps}&pe=${this.pe}&loc=G1`)
        .then((response) => {
          this.chart2.G1 = response.data;
        });
      axios
        .get(`${this.api}otp_sew.php/nike?ps=${this.ps}&pe=${this.pe}&loc=G2`)
        .then((response) => {
          this.chart2.G2 = response.data;
        });
      axios
        .get(`${this.api}otp_sew.php/nike?ps=${this.ps}&pe=${this.pe}&loc=G3`)
        .then((response) => {
          this.chart2.G3 = response.data;
        });
      axios
        .get(`${this.api}otp_sew.php/nike?ps=${this.ps}&pe=${this.pe}&loc=G4`)
        .then((response) => {
          this.chart2.G4 = response.data;
        });

      axios
        .get(`${this.api}otp_pack.php/nike?ps=${this.ps}&pe=${this.pe}&loc=`)
        .then((response) => {
          this.chart3.ALL = response.data;
        });
      axios
        .get(`${this.api}otp_pack.php/nike?ps=${this.ps}&pe=${this.pe}&loc=G1`)
        .then((response) => {
          this.chart3.G1 = response.data;
        });
      axios
        .get(`${this.api}otp_pack.php/nike?ps=${this.ps}&pe=${this.pe}&loc=G2`)
        .then((response) => {
          this.chart3.G2 = response.data;
        });
      axios
        .get(`${this.api}otp_pack.php/nike?ps=${this.ps}&pe=${this.pe}&loc=G3`)
        .then((response) => {
          this.chart3.G3 = response.data;
        });
      axios
        .get(`${this.api}otp_pack.php/nike?ps=${this.ps}&pe=${this.pe}&loc=G4`)
        .then((response) => {
          this.chart3.G4 = response.data;
        });
    },
    goPage(routerName) {
      this.$router.push({
        name: routerName,
      });
    },
  },
};
